import React, { Component } from "react";
import { TimelineMax, Back } from "gsap";

class Hero2 extends Component {
  componentDidMount() {
    this.tl = new TimelineMax({ delay: 0, ease: Back.easeOut, paused: true });
  }

  enterTransition = time => {
    this.tl.to(this.hero, time, { opacity: 1 });
    this.tl.play();
  };

  exitTransition = time => {
    this.tl.fromTo(
      this.hero,
      time,
      {
        opacity: 1
      },
      {
        transform: "translateX(-70px)",
        opacity: 0
      }
    );
    this.tl.play();
  };

  render = () => {
    return (
      <div id="hero2" className="section" ref={hero => (this.hero = hero)}>
        <div className="aboutText">
          JOJA is a web & mobile development team based in Vilnius, Lithuania.
          Over the years we’ve helped clients build great bespoke applications.
          <br />
          <br />
          Building web & mobile applications for startups and companies of all
          sizes. We provide UI/UX design, front-end & back-end development
          services with bleeding edge technologies. We specialize in full stack
          JavaScript.
        </div>
      </div>
    );
  };
}

export default Hero2;



// WEBPACK FOOTER //
// ./src/components/Front/Hero2.js